import React, { useEffect, useMemo, useRef, useState } from "react";
import videojs from "video.js";
import classNames from "classnames";
import { connect } from "react-redux";
import qualityLevels from "videojs-contrib-quality-levels";
import hlsQualitySelector from "videojs-hls-quality-selector";

import { play, setVolume, stop } from "../../../store/video/actions";
import { updatePreferredSubtitleLanguage } from "../../../store/actions";

import "video.js/dist/video-js.min.css";
import styles from "./index.module.scss";

const VideoPlayer = ({
  videoSrc,
  videoId,
  poster,
  video,
  play,
  stop,
  setVolume,
  className,
  tracks,
  auth,
  updatePreferredSubtitleLanguage,
  videoTracking
}) => {
  const [playerInstance, updatePlayerInstance] = useState(null);
  const { volume, nowPlaying } = video;
  const videoPlayerRef = useRef(null); // Instead of ID,
  const isMP4 = videoSrc.includes('.mp4?');
  const isCurrentVideoPlaying = useMemo(() => playerInstance && nowPlaying === videoId, [nowPlaying, playerInstance, videoId]);
  const startTime = useRef(null); // We are using null instead of 0 to check whether user have play the video, then it will update the startTime and on component unmount we will check whether it is not null then call the api
  const endTime = useRef(null);


  const source = isMP4
    ? {
      src: videoSrc,
      type: 'video/mp4',
    }
    : {
      src: videoSrc,
      type: 'application/x-mpegURL',
      withCredentials: true
    };

  const videoJSOptions = {
    controls: true,
    sources: [source],
    userActions: { hotkeys: true },
    controlBar: {
      pictureInPictureToggle: false,
    },
    textTrackSettings: false,
    html5: {
      // nativeTextTracks: false,
      nativeAudioTracks: false,
      nativeVideoTracks: false,
      vhs: {
        overrideNative: true,
      }
    },
    plugins: {
      qualityLevels: {},
      hlsQualitySelector: {
        displayCurrentQuality: true
      },
    },
    playbackRates: [0.5, 0.75, 1, 1.25, 1.5]
  };

  useEffect(() => {
    const plugins = videojs.getPlugins();

    if (!(qualityLevels in plugins) && !(hlsQualitySelector in plugins)) {
      videojs.registerPlugin("qualityLevels", qualityLevels);
      videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector);
    }

    if (videoPlayerRef) {
      const player = videojs(videoPlayerRef.current, videoJSOptions, () => {
        player.on("play", () => {
          play(videoId);
        });

        player.on("pause", () => {
          stop(videoId);
        });
        player.on("error", () => {
          stop();
        });
        player.on("ended", () => {
          stop();
        });
        player.on("volumechange", () => {
          setVolume(Math.floor(player.volume() * 100));
        });

        player.textTracks().on("change", function action(event) {
            const tracks = player.textTracks().tracks_;
            const showing = tracks.filter(function (track) {

              if (track.kind === "captions" && track.mode === "showing") {
                  return true;
              }
          })[0];
        })
      });

      updatePlayerInstance(player);

      return () => {
        player.dispose();
      };
    }

    return () => { };
  }, []);

  useEffect(() => {
    if (playerInstance) {
      playerInstance.volume(volume / 100);
    }

    if (playerInstance && nowPlaying !== videoId) {
      playerInstance.pause();
    }
  }, [video, playerInstance, nowPlaying, videoId, volume]);

  useEffect(() => {
    if (isCurrentVideoPlaying && (videoSrc !== playerInstance?.src()?.replaceAll(/#t=\d+\.?\d+?$/gm, ''))) {
      /* eslint-disable no-unused-expressions */
      playerInstance?.src(`${videoSrc}#t=${videoPlayerRef?.current?.currentTime}`);
      playerInstance?.load();
      playerInstance?.play();
      /* eslint-enable no-unused-expressions */
    }
  }, [videoSrc, playerInstance, isCurrentVideoPlaying]);
  
  // let trackLangToCompare = 'en';

  // if (user) {
  //   trackLangToCompare = user.preferredSubtitleLanguage || null;
  // }

  return (
    <div data-vjs-player>
      <video
        poster={poster}
        ref={videoPlayerRef}
        className={classNames("video-js", styles.sliderSlide, className)}
        controls
        playsInline
        onContextMenu={(event) => event.preventDefault()}
        crossorigin="use-credentials"
      >
        {/* {
          tracks && Object.keys(tracks).map((trackLang, index) => (
            <track
              key={index}
              kind="captions"
              src={tracks[trackLang]}
              srclang={trackLang}
              label={trackLang}
              default={trackLang === trackLangToCompare}
            />
          ))
        } */}
        {/* <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_en.vtt" srclang="en" label="en" default>
          </track>
          <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_es.vtt" srclang="es" label="es" default>
          </track>
          <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_fr.vtt" srclang="fr" label="fr" default>
          </track>
          <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_de.vtt" srclang="de" label="de" default>
          </track>
          <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_pt.vtt" srclang="pt" label="pt" default>
          </track>
          <track kind="captions" src="https://files.dev.wearecrossfader.co.uk/files/admins/crossfader_b8a52f96-2e93-4719-9412-183a1d0b10e0/translated/Captions_zh.vtt" srclang="zh" label="zh" default>
          </track> */}
        </video>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { Video: video, Auth: auth } = state;
  return { video, auth };
};

const mapDispatchToProps = {
  play,
  stop,
  setVolume,
  // updatePreferredSubtitleLanguage,
  // videoTracking
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoPlayer);
